var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "size": "lg",
      "options": _vm.srList,
      "name": "SrId",
      "placeholder": "Select SR",
      "selected-option": _vm.srItemObj
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.SrId),
      callback: function($$v) {
        _vm.SrId = $$v
      },
      expression: "SrId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.clearSR()
      }
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPendingShipment),
      expression: "searchPendingShipment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchPendingShipment",
      "type": "text",
      "name": "searchPendingShipment",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchPendingShipment)
    },
    on: {
      "change": _vm.filteredTableData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPendingShipment = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.srBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, _vm._l((_vm.srPriorities), function(priority) {
    return (_vm.getFlagVisibility('SR', priority)) ? _c('b-button', {
      key: priority,
      staticClass: "col-sm-2 m-1",
      attrs: {
        "size": "sm",
        "variant": _vm.getActiveVariant('SR', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsr', priority)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(priority) + " (" + _vm._s(_vm.getCount('SR', priority)) + ")\n                    ")]) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (_vm.svcBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, _vm._l((_vm.svcPriorities), function(priority) {
    return (_vm.getFlagVisibility('SVC', priority)) ? _c('b-button', {
      key: priority,
      staticClass: "col-sm-2 m-1",
      attrs: {
        "size": "sm",
        "variant": _vm.getActiveVariant('SVC', priority)
      },
      on: {
        "click": function($event) {
          return _vm.changeSelected('pendingsvc', priority)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(priority) + " (" + _vm._s(_vm.getCount('SVC', priority)) + ")\n                    ")]) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 pt-2"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px"
    },
    on: {
      "click": _vm.RefreshShipment
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })])])]), _vm._v(" "), (_vm.errorRvpAllocation || _vm.successRvpAllocation) ? _c('div', {
    staticClass: "col-md-12 mt-2",
    staticStyle: {
      "font-weight": "bold",
      "margin-bottom": "20px"
    }
  }, [_vm._l((_vm.errorRvpAllocationErrorArrobj), function(singleRvpError, index) {
    return _c('b-alert', {
      key: index,
      staticStyle: {
        "padding": "0%",
        "margin": "0%"
      },
      attrs: {
        "show": _vm.dismissCountDown,
        "dismissible": "",
        "fade": "",
        "variant": "danger"
      },
      on: {
        "dismiss-count-down": _vm.countDownChanged
      }
    }, [_vm._v("\n                    " + _vm._s(singleRvpError.shippingId) + " :- " + _vm._s(singleRvpError.message) + "\n                ")])
  }), _vm._v(" "), (_vm.successRvpAllocation || _vm.dismissCountDownSuccess > 0) ? _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.successRvpAllocation) + "\n                ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 table-responsive",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.CountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.CountLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive table-hover table-bordered tbl datatables",
    staticStyle: {
      "width": "100%",
      "height": "400px"
    }
  }, [_c('thead', [_c('tr', [(_vm.IsCheckbox) ? _c('th', {
    staticClass: "text-center tableheader sticky-header"
  }, [(_vm.IsCheckbox && _vm.checkboxDisabled) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllCheckbox),
      expression: "selectAllCheckbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllCheckbox) ? _vm._i(_vm.selectAllCheckbox, null) > -1 : (_vm.selectAllCheckbox)
    },
    on: {
      "click": _vm.selectAllItems,
      "change": function($event) {
        var $$a = _vm.selectAllCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllCheckbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllCheckbox = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.IsCheckbox && !_vm.checkboxDisabled) ? _c('span', [_vm._v("Select")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.PendingColumns), function(col, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center tableheader sticky-header sticky-last"
    }, [_vm._v("\n                                " + _vm._s(col.label) + "\n                            ")])
  })], 2)]), _vm._v(" "), _c('tbody', [(!_vm.showUnallocatedListFilter.length) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": 12
    }
  }, [_c('h1', [_vm._v("No Record Found")])])]) : _vm._l((_vm.showUnallocatedListFilter), function(row, index) {
    return _c('tr', {
      key: index
    }, [(_vm.IsCheckbox) ? _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "col-sm-4",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('b-badge', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      }
    }, [_vm._v(_vm._s(row.Bucket))])], 1), _vm._v(" "), (row.TotalAttemptCount > 0) ? _c('div', {
      staticClass: "col-sm-4"
    }, [_c('b-badge', {
      attrs: {
        "size": "sm",
        "variant": "warning"
      }
    }, [_vm._v("A" + _vm._s(row.TotalAttemptCount))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItemsOnChild),
        expression: "selectedItemsOnChild"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.selectedItemsOnChild) ? _vm._i(_vm.selectedItemsOnChild, row) > -1 : (_vm.selectedItemsOnChild)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItemsOnChild,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItemsOnChild = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItemsOnChild = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItemsOnChild = $$c
          }
        }, function($event) {
          return _vm.selectedItemdata($event, row)
        }]
      }
    })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.PendingColumns), function(col, colIndex) {
      return _c('td', {
        key: colIndex,
        staticClass: "text-center",
        style: (col.size)
      }, [(col.label === 'AWB|MPS') ? _c('span', [_vm._v("\n                                        " + _vm._s(row[col.key[0]]) + " "), _c('br'), _vm._v(_vm._s(row[col.key[1]]) + "\n                                        "), (row[col.key[2]] > 0) ? _c('span', {
        staticStyle: {
          "background": "yellow"
        }
      }, [_c('br'), _vm._v(_vm._s(row[col.key[2]]) + " items\n                                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (col.type === 'text') ? _c('span', [_vm._v(_vm._s(row[col.key]))]) : _vm._e()])
    })], 2)
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(_vm.selectedItemsOnChild.length > 0) ? _c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.processShipments()
      }
    }
  }, [_vm._v("Unallocate")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedItemsOnChild.length > 0) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedItemsOnChild.length) + " Shipments selected")])]) : _vm._e(), _vm._v(" "), (_vm.SrId != '' && _vm.showUnallocatedListFilter.length > 0) ? _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.CheckPDD()
      }
    }
  }, [_vm._v("Confirm Allocation")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.NonAllocationRsn == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.NonAllocationRsn),
      callback: function($$v) {
        _vm.NonAllocationRsn = $$v
      },
      expression: "NonAllocationRsn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alert - Heavies Shipments")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.BucketName == 'Heavies') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.heaviesTitleName1)), _c('h6', [_c('b', [_vm._v(_vm._s(_vm.heaviesTitleName2))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3 table-responsive",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', {
    staticClass: "thead-default tablehead"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipments")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.SEQShippingids), function(shipmentId, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipmentId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitHeavies()
      }
    }
  }, [_vm._v("Continue")]), _vm._v("     \n                                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseNonAllocationRsn()
      }
    }
  }, [_vm._v("cancel")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.RVPSPendingShipmentModelFlag == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.RVPSPendingShipmentModelFlag),
      callback: function($$v) {
        _vm.RVPSPendingShipmentModelFlag = $$v
      },
      expression: "RVPSPendingShipmentModelFlag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.RVPSPendingTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseRVPSPendingShipmentModelFlag()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('table', {
    staticClass: "table-bordered table-responsive",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default tablehead"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending allocation")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment count")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.cantAllocatePopupArray), function(priority) {
    return (_vm.getRVPPendingCount(priority) > 0) ? _c('tr', {
      key: priority,
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(priority) + " Shipments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getRVPPendingCount(priority)))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Priority Shipments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalPriorityShipments()))])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseRVPSPendingShipmentModelFlag()
      }
    }
  }, [_vm._v(" Can't Allocate")]), _vm._v("     \n                                "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ViewRVPPendingShipments()
      }
    }
  }, [_vm._v("View pending priority shipments")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.startModelUnallocate == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startModelUnallocate),
      callback: function($$v) {
        _vm.startModelUnallocate = $$v
      },
      expression: "startModelUnallocate"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.MPSTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelMPS(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "sty": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "border-right": "1px solid",
      "color": "black"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.MPSSrNameTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSNote))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSAddress))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.MPSCount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseModelMPS(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getSameMPSGroupShipmentsRVP2(_vm.MPSSelectedRow, _vm.MPSRows, _vm.MPSActionType)
      }
    }
  }, [_vm._v("ok")])])])])]) : _vm._e(), _vm._v(" "), (_vm.RVPSCantAllcatePriorityShipmentModelFlag == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.RVPSCantAllcatePriorityShipmentModelFlag),
      callback: function($$v) {
        _vm.RVPSCantAllcatePriorityShipmentModelFlag = $$v
      },
      expression: "RVPSCantAllcatePriorityShipmentModelFlag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.RVPSCantPendingTitle))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.CloseRVPSCantAllcatePriorityShipmentModelFlag()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 mt-3"
  }, [_c('table', {
    staticClass: "table-bordered table-responsive",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.nonAlloationReasons), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "text-center"
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cantAllocatedchangeStatus),
        expression: "cantAllocatedchangeStatus"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": {
          'reasonCode': item.uniquecode,
          'reasonText': item.title
        },
        "checked": _vm._q(_vm.cantAllocatedchangeStatus, {
          'reasonCode': item.uniquecode,
          'reasonText': item.title
        })
      },
      on: {
        "change": function($event) {
          _vm.cantAllocatedchangeStatus = {
            'reasonCode': item.uniquecode,
            'reasonText': item.title
          }
        }
      }
    }), _vm._v("  " + _vm._s(item.title) + "\n                                            ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.CloseRVPSCantAllcatePriorityShipmentModelFlag()
      }
    }
  }, [_vm._v(" Cancel")]), _vm._v("     \n                                "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveCantAllocateShipment()
      }
    }
  }, [_vm._v("Proceed with confirm allocation")])])])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.SrName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm"
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorOpenKM),
      expression: "errorOpenKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorOpenKM))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == '' || _vm.openKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dde25f4","hasScoped":true}!./src/views/components/newallocationpagev2/ReverseConfirmAllocation/reverseconfirmallocation.html
// module id = 1550
// module chunks = 1